import type { CenterEmployeeOut } from '../../types/centerApplicationTypes'
import { normalizeRoleOrType } from '../../utils/stringHelpers'

interface EmployeesTableProps {
  employees: CenterEmployeeOut[]
}

export default function EmployeesTable({ employees }: EmployeesTableProps) {
  if (!employees || employees.length === 0) {
    return (
      <div className="bg-white rounded-lg p-6">
        <h3 className="text-lg font-semibold text-[#A6410A] mb-4">
          Center Employees
        </h3>
        <p className="text-gray-500 text-center py-8">No employees listed</p>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg p-6">
      <h3 className="text-lg font-semibold text-[#A6410A] mb-4">
        Center Employees ({employees.length})
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-2 text-sm font-medium text-gray-700">
                Name & Info
              </th>
              <th className="text-left py-3 px-2 text-sm font-medium text-gray-700">
                Role
              </th>
              <th className="text-left py-3 px-2 text-sm font-medium text-gray-700">
                Type
              </th>
            </tr>
          </thead>
          <tbody>
            {employees.map((employee) => (
              <tr
                key={employee.id}
                className="border-b border-gray-100 hover:bg-gray-50"
              >
                <td className="py-3 px-2 text-sm text-gray-900">
                  {employee.name_and_info || employee.name || 'N/A'}
                  {(employee.is_director || employee.is_co_director) && (
                    <span className="ml-2 text-xs text-[#A6410A] font-medium">
                      {employee.is_director && '(Director)'}
                      {employee.is_co_director && '(Co-Director)'}
                    </span>
                  )}
                </td>
                <td className="py-3 px-2 text-sm text-gray-600">
                  {normalizeRoleOrType(employee.role) || 'N/A'}
                </td>
                <td className="py-3 px-2 text-sm text-gray-600">
                  {normalizeRoleOrType(employee.employee_type) || 'N/A'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
